import { Controller } from "@hotwired/stimulus";

// Gathers per-photo quantities from the photo library grid and serializes
// them into the form before it submits. The grid uses the existing
// `order/photos/_photo` partial; each `.photo-item[data-photo-id]` exposes
// the chosen quantity via the nested `photo-quantity` input.
export default class extends Controller {
  static values = { message: { type: String, default: "" } };

  static targets = ["photosPayload"];

  submit(event) {
    const items = this.element.querySelectorAll(".photo-item[data-photo-id]");
    const payload = [];

    items.forEach((item) => {
      const photoId = item.dataset.photoId;
      const input = item.querySelector(
        '[data-photo-quantity-target="input"]'
      );
      const quantity = input ? parseInt(input.value, 10) : 0;
      if (Number.isNaN(quantity) || quantity <= 0) return;
      payload.push({ photo_id: photoId, quantity });
    });

    if (payload.length === 0) {
      event.preventDefault();
      alert(this.messageValue);
      return;
    }

    this.photosPayloadTarget.value = JSON.stringify(payload);
  }
}
